function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Pen",
  opacity: 1
}, /*#__PURE__*/React.createElement("path", {
  opacity: 1,
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 4.816,
  strokeOpacity: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M 316.139 427.492 L 624.816 152.906 L 606.393 587.538 L 314.646 426.531 Z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 1,
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 4.816,
  strokeOpacity: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M 316.139 427.492 L 624.816 152.906 L 284.378 322.523 L 315.181 427.196 Z"
}));

var _ref3 = /*#__PURE__*/React.createElement("style", null, "\n    .face { font: bold 100px sans-serif; color: #000; }\n  ");

var _ref4 = /*#__PURE__*/React.createElement("text", {
  x: 480,
  y: 380,
  className: "face",
  rotate: 30
}, "4");

var SvgD4 = function SvgD4(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3in",
    height: "3in",
    viewBox: "273.622864 143.397644 360.203491 453.166077",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgD4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/D4.9ce47f68.svg";
export { ForwardRef as ReactComponent };